var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCottageActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99896 18.9877V11.6127L2.99896 12.3877C2.76563 12.5544 2.51562 12.621 2.24896 12.5877C1.98229 12.5544 1.76562 12.421 1.59896 12.1877C1.43229 11.9544 1.36563 11.7044 1.39896 11.4377C1.43229 11.171 1.55729 10.9544 1.77396 10.7877L3.99896 9.0877V6.9877C3.99896 6.70437 4.09479 6.46687 4.28646 6.2752C4.47813 6.08353 4.71563 5.9877 4.99896 5.9877C5.28229 5.9877 5.51979 6.08353 5.71146 6.2752C5.90312 6.46687 5.99896 6.70437 5.99896 6.9877V7.5627L10.774 3.9127C11.1406 3.62937 11.549 3.4877 11.999 3.4877C12.449 3.4877 12.8573 3.62937 13.224 3.9127L22.224 10.7877C22.4406 10.9544 22.5656 11.171 22.599 11.4377C22.6323 11.7044 22.5656 11.9544 22.399 12.1877C22.2323 12.4044 22.0156 12.5294 21.749 12.5627C21.4823 12.596 21.2406 12.5294 21.024 12.3627L19.999 11.6127V18.9877C19.999 19.5377 19.8031 20.0085 19.4115 20.4002C19.0198 20.7919 18.549 20.9877 17.999 20.9877H5.99896C5.44896 20.9877 4.97813 20.7919 4.58646 20.4002C4.19479 20.0085 3.99896 19.5377 3.99896 18.9877ZM5.99896 18.9877H10.999V15.9877C10.999 15.7044 11.0948 15.4669 11.2865 15.2752C11.4781 15.0835 11.7156 14.9877 11.999 14.9877C12.2823 14.9877 12.5198 15.0835 12.7115 15.2752C12.9031 15.4669 12.999 15.7044 12.999 15.9877V18.9877H17.999V10.0877L11.999 5.5127L5.99896 10.0877V18.9877Z",
    fill: "#4BD7D1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCottageActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cottage-active.596f511e07eee3337d4fd31d29dce2d1.svg";